module.exports = __webpack_public_path__ + "img/Hero-min-small.57baa907.jpg";